module.exports = __webpack_public_path__ + "img/img_apps_mobile.4fa0069.png";